import {
	REFRESH_SEARCH_PROFILE,
	GET_SEARCH_PROFILE,
	SET_SEARCH_PROFILE,
	SET_SORT_PROFILE
} from './types'

const initialState = {
	refresh: false,
	loadMore: true,
	initialize: true,
	isRequesting: false,
	page: 1,
	results: [],
	sort:'asc'
};

const reducer = (state = initialState, { type, payload }) => {

	switch (type) {

		case REFRESH_SEARCH_PROFILE:
			return {
				...state,
				refresh: true,
				loadMore: true,
				initialize: true,
				isRequesting: false,
				page: 1,
				results: [],
				// sort:'asc'
			}

		case GET_SEARCH_PROFILE:
			return {
				...state,
				isRequesting: true,
			}

		case SET_SEARCH_PROFILE:
			let newResults = state.results

			payload.data.forEach((p) => {
				const result = state.results.filter(
					(u) => u.id === p.id
				);
				if (!result.length) {
					newResults.push(p);
				}
			});
			 let data = [];
			 if (payload.sort === 'asc') {
				data = newResults.sort((a, b) => a.profile_name.localeCompare(b.profile_name));
				} else {
				data = newResults.sort((a, b) => b.profile_name.localeCompare(a.profile_name));
			}

			return {
				...state,
				refresh: false,
				initialize: false,
				isRequesting: false,
				page: payload.page,
				loadMore: payload.loadMore,
				results: data,
				sort:payload.sort
			}
		case SET_SORT_PROFILE:
			return {
				...state,
				sort:payload.sort,
				results: payload.data
			}


		default:
			return state;

	}

}

export default reducer